// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-container[data-v-3adfc218] {\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0px 4px 40px 0px rgba(204, 213, 212, 0.3);\n}", ""]);
// Exports
module.exports = exports;
